import {React,useEffect,useState,useContext} from 'react'
import axios from "axios";
import { GlobalLoading, showLoading } from 'react-global-loading';
import { MyContextProvider } from "../../../App";
import {API_URL}  from '../../../Constant';
import {generateExcel} from '../../../Custom/ExportExcel';
import {changeDateFormat,shortMonthToFull,validateRoles} from "../../../Custom/Custom";
import { ToastContainer, toast } from 'react-toastify';
import messages from '../../../assets/Messages.json';
import titlesData from '../../../titles.json';
import { jwtDecode } from 'jwt-decode';
import { useNavigate } from "react-router-dom";

function RejectedPriceWagesReport() {

  const currentDate = new Date();
  const prevMonthDate = new Date(currentDate);
  prevMonthDate.setMonth(currentDate.getMonth() - 1);
  const prevMonthName = prevMonthDate.toLocaleString('default', { month: 'short' }).toUpperCase();

  const [years,setYears]=useState([]);
  const [yearName,setyearName]=useState(new Date().getFullYear());
  const [months,setMonth]=useState([]);
  const [monthName,setMonthName]=useState(prevMonthName);
  const [reportData, setReportData] = useState([]);
  const token=useContext(MyContextProvider).token;
  const navigate = useNavigate();

  const config = {
      headers: {
          Authorization: `Bearer ${token}`,
      },
    };
    


useEffect(() => { //Get all Years Data

   //Years
      const fetchYears = async () => {


        const decodedToken = jwtDecode(token);
        const role = await validateRoles(decodedToken);
  
        if (!role) {
          alert("You are not an authorized user to capture the data for Pricing");
          navigate("/dashboard");
          return;
        }

      showLoading(true)
      const currentYear = new Date().getFullYear();
      const endYear = 2021;
      const yearsArray = [];

      for (let year = currentYear; year >= endYear; year--) {
        yearsArray.push(year);
      }

      setYears(yearsArray);
    
  axios
     .get(`${API_URL}api/graph/getMonths/2019`,config)
          .then((res) => {
            let monthDataResponse=res.data;
            if(monthDataResponse.status){
                setMonth(monthDataResponse.data);
                
              }
              showLoading(false)
         })
          .catch((err) =>{
            console.log(err)
            showLoading(false)
          });
        }

      fetchYears();
       
          
}, []);
  

    const handleSubmit=(e)=>{
       showLoading(true)
      
     axios
      .get(`${API_URL}api/consumerRetail/getUrbanConsumerRetailPriceExcelData?month=${monthName}&year=${yearName}`,config)
           .then((res) => {
             if(res.data.status && res.data.data){
               setReportData(res.data.data);
               showLoading(false);
               // Directly generate Excel after data is fetched
               generateExcelFromData(res.data.data);
             } else {
               setReportData([]);
               showLoading(false);
               toast.error('No data found for the selected month and year.', messages.COLOR_RED);
             }
           })
           .catch((err) =>{ 
            console.log(err)
            setReportData([]);
            showLoading(false);
            toast.error('Error fetching data. Please try again.', messages.COLOR_RED);
           });
           
    }

    // Function to generate Excel from data
    const generateExcelFromData = (data) => {
      if (!data || data.length === 0) {
        toast.error('No data available to export', messages.COLOR_RED);
        return;
      }

      // Get all unique districts
      const uniqueDistricts = [...new Set(data.map(item => item.districtName).filter(Boolean))].sort();
      
      // Get all unique items (itemNameHindi)
      const uniqueItems = [...new Set(data.map(item => item.itemNameHindi).filter(Boolean))].sort();
      
      // Create a map for quick lookup: district -> item -> price
      const dataMap = {};
      data.forEach(item => {
        if (!item.districtName || !item.itemNameHindi) return;
        
        if (!dataMap[item.districtName]) {
          dataMap[item.districtName] = {};
        }
        dataMap[item.districtName][item.itemNameHindi] = item.currentPrice || '';
      });
      
      // Build header columns: Sr No., District Unit, then all unique items
      const headerColumns = ['Sr No.', 'District Unit', ...uniqueItems];
      
      // Calculate merge cells based on number of columns
      const totalColumns = headerColumns.length;
      const getColumnLetter = (num) => {
        let result = '';
        while (num > 0) {
          num--;
          result = String.fromCharCode(65 + (num % 26)) + result;
          num = Math.floor(num / 26);
        }
        return result || 'A';
      };
      const lastColumn = getColumnLetter(totalColumns);
      
      // Build excel row data
      const excelRowData = uniqueDistricts.map((district, index) => {
        const row = [index + 1, district];
        uniqueItems.forEach(item => {
          const price = dataMap[district] && dataMap[district][item] ? dataMap[district][item] : '';
          row.push(price);
        });
        return row;
      });

      const excelObjectData = {
        fileName: "Rejected_UrbanConsumerRetailPriceReport",
        reportType: "Rejected_UrbanConsumerRetailPriceReport",
        fileType:'xls',
        sheetName:"RejectedPriceWages",
        firstRowMergeCells:`A1:${lastColumn}1`,
        firstRowText:`Scrutiny of Urban Price of the month ${monthName} ------ ${yearName} (Rejected price of the Items)`,
        firstRowExportDate:changeDateFormat(new Date()),
        firstRowCellNumber:totalColumns,
        headerHindiColumns: headerColumns,
        excelRowData: excelRowData
      };
      
      generateExcel(excelObjectData);
    }

    // Generate Excel
    const handleGenerateExcel = () => {
      if (!monthName || !yearName) {
        toast.error('Please select Month and Year', messages.COLOR_RED);
        return;
      }

      if (!reportData || reportData.length === 0) {
        toast.error('First, search the data, then export as excel', messages.COLOR_RED);
        return;
      }

      // Get all unique districts
      const uniqueDistricts = [...new Set(reportData.map(item => item.districtName).filter(Boolean))].sort();
      
      // Get all unique items (itemNameHindi)
      const uniqueItems = [...new Set(reportData.map(item => item.itemNameHindi).filter(Boolean))].sort();
      
      // Create a map for quick lookup: district -> item -> price
      const dataMap = {};
      reportData.forEach(item => {
        if (!item.districtName || !item.itemNameHindi) return;
        
        if (!dataMap[item.districtName]) {
          dataMap[item.districtName] = {};
        }
        dataMap[item.districtName][item.itemNameHindi] = item.currentPrice || '';
      });
      
      // Build header columns: Sr No., District Unit, then all unique items
      const headerColumns = ['Sr No.', 'District Unit', ...uniqueItems];
      
      // Calculate merge cells based on number of columns
      const totalColumns = headerColumns.length;
      const getColumnLetter = (num) => {
        let result = '';
        while (num > 0) {
          num--;
          result = String.fromCharCode(65 + (num % 26)) + result;
          num = Math.floor(num / 26);
        }
        return result || 'A';
      };
      const lastColumn = getColumnLetter(totalColumns);
      
      // Build excel row data
      const excelRowData = uniqueDistricts.map((district, index) => {
        const row = [index + 1, district];
        uniqueItems.forEach(item => {
          const price = dataMap[district] && dataMap[district][item] ? dataMap[district][item] : '';
          row.push(price);
        });
        return row;
      });

      const excelObjectData = {
        fileName: "Rejected_UrbanConsumerRetailPriceReport",
        reportType: "Rejected_UrbanConsumerRetailPriceReport",
        fileType:'xls',
        sheetName:"RejectedPriceWages",
        firstRowMergeCells:`A1:${lastColumn}1`,
        firstRowText:"Rejected Price Wages Report",
        firstRowExportDate:changeDateFormat(new Date()),
        firstRowCellNumber:totalColumns,
        secondRowMergeCells:`A2:${lastColumn}2`,
        secondRowText:`${monthName}-${yearName}`,
        secondRowCellNumber:totalColumns,
        headerHindiColumns: headerColumns,
        excelRowData: excelRowData
      };
      
      generateExcel(excelObjectData);
    }

    const storedLanguage = localStorage.getItem('language');

  return (
    <>
    <ToastContainer />
    <GlobalLoading />

 <div className="container-fluid py-3">
     <div className="card mx-3 mb-3">
        <div className="card-body pb-1">
          <div className="row align-items-center">
           <h4 className="page_heading"><span className="text_orange"> Price Wages Indices System Rejected Report</span> Rejected Price Wages Report</h4>
            <div className="col-xl-2 col-lg-4 col-md-4 col-sm-4 col-6 mb-3">
                <label>Month</label>
                
                <select value={monthName} onChange={(e)=>(setMonthName(e.target.value))} name="month_name" className="form-select">
                  <option value="" disabled>Select Month</option>
                  {months && months.map((ele,i)=>(
                    <option key={i} value={ele.MONTH}>{shortMonthToFull(ele.MONTH)}</option>
                  ))

                  }
                </select>
                
            </div>
            
            <div className="col-xl-2 col-lg-4 col-md-4 col-sm-4 col-6 mb-3">
                <label>Year</label>
                <select value={yearName} onChange={(e)=>(setyearName(e.target.value))} name="year_name"  className="form-select" >
                  <option value="" disabled >Select Year</option>
                  {years.map((ele, index) => (
                    <option key={index} value={ele}>
                      {ele}
                    </option>
                  ))}

              </select>
            </div>
         
        <div className="col-xl-2 col-lg-4 col-md-4 col-sm-4 col-12 mb-3">
            <label className="w-100 d-none d-sm-block">&nbsp;</label>
            <button onClick={handleSubmit} type="submit" className="btn btn_orange">Search</button>
        </div>
        </div>
      </div> 
     </div>
     
    
</div>
 
 </>
  )
}

export default RejectedPriceWagesReport
